import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ModalController } from "@ionic/angular";
import { PublishLettersService } from "src/app/services/publish-letters.service";
import { PublishLettersModalComponent } from "./publish-letters-modal/publish-letters-modal.component";

@Component({
  selector: 'app-publish-letters',
  templateUrl: './publish-letters.component.html',
  styleUrls: ['./publish-letters.component.scss'],
})
export class PublishLettersComponent implements OnInit {
  isLoading: boolean = false;

  docType: {key: string, value: string};
  lottery: {key: number, value: string};
  lotteryList: {[key:number]:string};
  docTypes: {[key:string]:string};

  constructor(
    private publishLetterService: PublishLettersService,
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController
  ) {} 

  ngOnInit() {
    this.isLoading = true;
    this.publishLetterService
    .publishDocumentsInitForm()
    .subscribe((data: any) => {
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.lotteryList = data.lotteryList;
        this.docTypes = data.docTypes;
      }
      else {
        this.publishLetterService.errorToast(data.errorMessage);
      }
    }, error => {
      this.isLoading = false;
      this.publishLetterService.errorToast(error.errorMessage||error.error.errorMessage);
    });
  }

  fetchLettersForPublish() {
    if(this.lottery) {
      if(this.docType) {
        this.publishLetterService
        .publishDocumentsFetchDocsForPublish(this.lottery.key, this.docType.key)
        .subscribe(async (data: any) => {
          let lotteryCode = data.lotteryCode;
          let lotteryName = data.lotteryName;
          let fileCount = data.fileCount;
          if(data.status === 'SUCCESS') {
            const modal = await this.modalCtrl.create({
              component: PublishLettersModalComponent,
              cssClass: 'master-modal',
              componentProps: {
                docType: this.docType,
                lotteryKey: this.lottery.key,
                lotteryCode: lotteryCode,
                lotteryName: lotteryName,
                fileCount: fileCount
              }
            });
            modal.present();
        
            const { data, role } = await modal.onWillDismiss();
              
            if(role === 'submit') {
              
            }
          }
          else {
            this.publishLetterService.errorToast(data.errorMessage);  
          }
        }, error => {
          this.publishLetterService.errorToast(error.errorMessage||error.error.errorMessage);
        });
      }
      else {
        this.publishLetterService.errorToast('Please select Letter Type.');  
      }
    }
    else {
      this.publishLetterService.errorToast('Please select Lottery.');
    }
  }

  async successToast() {
    await this._snackBar.open(
      "Lottery details saved successfully.",
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async warningToast() {
    await this._snackBar.open("Please Upload Logo", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

}
